import { Order } from "@/types/order";

/** 订单状态 */
export enum OrderStatusEnum {
    /** 卖家请求交易，等待卖家确认 */
    BUYER_REQUEST = "WaitingSellerConfirm",

    // STEP 1
    HANGING = 1,
    // STEP 2 
    /** 卖家取消订单 */
    SELLER_CANCELED_DEAL = "SellerCancelsPurchase",
    // STEP 3
    /** 等待买家付款 */
    WAITING_FOR_TRANSFER = "WaitingBuyerPay",
    // STEP 4
    /** 买家确认已经付款 */
    TRANSFERRED = "BuyerConfirmsOrderHasBeenPaid",


    /** 买家未付款，买家取消交易 */
    BUYRER_CANCELD_DEAL = "BuyerNotPay",
    /** 买家支付时超时 */
    TIME_OVER = "BuyerPaymentExceedsTimeLimit",
    
    /** 卖家确认未收到付款 */
    SELLER_DID_NOT_RECEIVE = "SellerHasNotReceivedPayment",
    /** 订单有争议 */
    DISPUTING = "BuyerAppeals",
    /** 官方取消（作废）订单 */
    CANCELED_BY_OFFICIAL = "AdminCancelsOrder",
    /** 官方确认（完成）订单 */
    CONFIRMED_BY_OFFICIAL = "AdminCompletesOrder",
    /** 交易完成 */
    DEAL = "SellerCompletesOrder",
    /** 买家没有发起争议 */
    BUYER_NOT_APPEALS = "BuyerNotAppeals",
    /** 区块订单 归集成功 */
    TRANSACTION_SUCCESS = "归集成功",
}


export const orderStatusList: Order.OrderStatus[] = [
  {
    key: OrderStatusEnum.SELLER_CANCELED_DEAL,
    text: "卖家取消交易",
    color: "#F76260",
  },
  { key: OrderStatusEnum.BUYER_REQUEST, text: "买家发起交易", color: "#F90" },

  {
    key: OrderStatusEnum.WAITING_FOR_TRANSFER,
    text: "等待买家转账",
    color: "#21A2FF",
  },
  {
    key: OrderStatusEnum.BUYRER_CANCELD_DEAL,
    text: "买家取消交易",
    color: "#FF4040",
  },
  { key: OrderStatusEnum.TIME_OVER, text: "超时取消交易", color: "#009583" },
  { key: OrderStatusEnum.TRANSFERRED, text: "买家已转账", color: "#6100FF" },
  {
    key: OrderStatusEnum.SELLER_DID_NOT_RECEIVE,
    text: "卖家未收到款",
    color: "#00BBB0",
  },
  { key: OrderStatusEnum.DISPUTING, text: "争议订单", color: "#888" },
  {
    key: OrderStatusEnum.CANCELED_BY_OFFICIAL,
    text: "平台取消交易",
    color: "#FF6534",
  },
  {
    key: OrderStatusEnum.CONFIRMED_BY_OFFICIAL,
    text: "平台确认交易",
    color: "#002195",
  },
  { key: OrderStatusEnum.DEAL, text: "交易完成", color: "#009506" },
  {
    key: OrderStatusEnum.BUYER_NOT_APPEALS,
    text: "申诉期未申诉",
    color: "#65790C",
  },
  {
    key: OrderStatusEnum.TRANSACTION_SUCCESS,
    text: "归集成功",
    color: "#009506",
  },
];

export const orderStatusMap: Order.OrderStatusMap = orderStatusList.reduce(
  (prev: Order.OrderStatusMap, cur) => {
    prev[cur.key] = cur;
    return prev;
  },
  {},
);
